// import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import BarChart1 from './common/BarChart1';
import { CONST_BUSINESS_MAIL, CONST_SITE_LABEL, formatValuesInK } from './common/Helper';
import GridLoader from './common/contentloader/GridLoader';
import './common/Styles.css'
import { Link, useLocation, useParams } from 'react-router-dom';
import DebugService from '../services/DebugService';
import { useEffect, useState } from 'react';

export default function DashboardCapture() {

  const [totalMonthlyCost, setTotalMonthlyCost] = useState('0')
  const [totalMonthlySaving, setTotalMonthlySaving] = useState('0')
  const [totalMonthlySavingPer, setTotalMonthlySavingPer] = useState('0')

  const [EC2MonthlySaving, setEC2MonthlySaving] = useState('0')
  const [EC2Barchart, setEC2BarChart] = useState([])

  const [EBSMonthlySaving, setEBSMonthlySaving] = useState('0')
  const [EBSBarchart, setEBSBarChart] = useState([])

  const [RDSMonthlySaving, setRDSMonthlySaving] = useState('0')
  const [RDSBarchart, setRDSBarChart] = useState([])

  // const [S3MonthlySaving, setS3MonthlySaving] = useState('0')

  const [isLoading, setIsLoading] = useState(false)

  // const navigate = useNavigate()
  // const { payload } = useParams()
  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)

  const summary = [
    { title: 'Forecast Cost', value: `$${totalMonthlyCost}K` },
    { title: 'Forecast Possible Saving', value: `$${totalMonthlySaving}K` },
    { title: '% of Forecast Possible Saving', value: `${totalMonthlySavingPer}%` },
  ]

  const fetchData = async () => {
    setIsLoading(true)

    try {
      const payload = queryParams.get('payload')
      DebugService.log(`Dashboard Capture Service: data`, payload)
      if (payload) {
        const decodedData = JSON.parse(atob(payload) ?? '') ?? {}

        if (Object.keys(decodedData).length > 0 && decodedData['data']) {
          const dashboardData = decodedData['data']

          const totalMonthlyCost = dashboardData['FORECAST_COST'] ? dashboardData['FORECAST_COST']['forecastedCostValue'] : 0

          const EC2MonthlyCost = dashboardData['EC2'] ? dashboardData['EC2']['currentCost'] : 0
          const EC2MonthlyRecommendedCost = dashboardData['EC2'] ? dashboardData['EC2']['recommendedCost'] : 0
                  
          const RDSMonthlyCost = dashboardData['RDS'] ? dashboardData['RDS']['currentCost'] : 0
          const RDSMonthlyRecommendedCost = dashboardData['RDS'] ? dashboardData['RDS']['recommendedCost'] : 0
                  
          const EBSMonthlyCost = dashboardData['EBS'] ? dashboardData['EBS']['currentCost'] : 0
          const EBSMonthlyRecommendedCost = dashboardData['EBS'] ? dashboardData['EBS']['recommendedCost'] : 0

          const totalCost = EC2MonthlyCost + RDSMonthlyCost + EBSMonthlyCost
          const totalRecommendedCost = EC2MonthlyRecommendedCost + RDSMonthlyRecommendedCost + EBSMonthlyRecommendedCost

          // Fetch total savings
          const totalMonthlySaving = totalCost - totalRecommendedCost

          // Total
          setTotalMonthlyCost(formatValuesInK(totalMonthlyCost))
          setTotalMonthlySaving(formatValuesInK(totalMonthlySaving))

          const percent = (totalMonthlySaving / totalMonthlyCost) * 100
          setTotalMonthlySavingPer(percent.toFixed(2))

          // EC2
          setEC2MonthlySaving(formatValuesInK(EC2MonthlyCost - EC2MonthlyRecommendedCost))
          const EC2BarChartData = [
            { name: 'Cost', value: formatValuesInK(EC2MonthlyCost), fill: '#FF6600' },
            { name: 'Savings', value: formatValuesInK(EC2MonthlyCost - EC2MonthlyRecommendedCost), fill: '#00CC33' },
          ];
          setEC2BarChart(EC2BarChartData)

          // EBS
          setEBSMonthlySaving(formatValuesInK(EBSMonthlyCost - EBSMonthlyRecommendedCost))
          const EBSBarChartData = [
            { name: 'Cost', value: formatValuesInK(EBSMonthlyCost), fill: '#FF6600' },
            { name: 'Savings', value: formatValuesInK(EBSMonthlyCost - EBSMonthlyRecommendedCost), fill: '#00CC33' },
          ];
          setEBSBarChart(EBSBarChartData)

          // RDS
          setRDSMonthlySaving(formatValuesInK(RDSMonthlyCost - RDSMonthlyRecommendedCost))
          const RDSBarChartData = [
            { name: 'Cost', value: formatValuesInK(RDSMonthlyCost), fill: '#FF6600' },
            { name: 'Savings', value: formatValuesInK(RDSMonthlyCost - RDSMonthlyRecommendedCost), fill: '#00CC33' },
          ];
          setRDSBarChart(RDSBarChartData)
        }
      }

      setIsLoading(false)
    } catch (err) {
      DebugService.error(`Dashboard Capture Service: Error Caught while fetching data`, err)
      setIsLoading(false)
    }
  }

  useEffect(() => {
    document.title = `${CONST_SITE_LABEL} | Dashboard Capture`
    fetchData()
  }, [])

  return (
    <Box
      component="main"
      flexGrow={1}
      minHeight="100vh"
      height="100%"
      overflow="hidden"
      bgcolor={(theme) =>
        theme.palette.mode === "light"
          ? theme.palette.grey[100]
          : theme.palette.grey[900]
      }
    >
      <Container
        fixed
        maxWidth="false"
        style={{ marginTop: "10px" }}
      >
        {isLoading ? (
          <GridLoader />
        ) : (
          <>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <Link title="Home" href="/" className="error-home-link">
                  <img
                    src="/logo-black.png"
                    alt={CONST_SITE_LABEL}
                    width={100}
                  />
                </Link>
              </Grid>
              <Grid item xs={12} md={6} style={{ textAlign: "right" }}>
                <a
                  href={`mailto:${CONST_BUSINESS_MAIL}`}
                  style={{
                    textDecoration: "none",
                    color: "#191970",
                    fontWeight: "500",
                  }}
                >
                  {CONST_BUSINESS_MAIL}
                </a>
              </Grid>
            </Grid>

            <Grid container spacing={3} className="dashboard-page">
              {/* Summary */}
              {summary.map((s, i) => (
                <Grid item xs={12} md={4} key={i}>
                  <Paper elevation={12} className={`summary-el saving${i + 1}`}>
                    <div>
                      <img
                        src={`/saving${i + 1}-icon.svg`}
                        alt={`${"s.title"}`}
                      />
                    </div>
                    <div>
                      <Typography variant="p">{s.title}</Typography>
                      <Typography variant="h4" color={"#012A4A"}>
                        {s.value}
                      </Typography>
                    </div>
                  </Paper>
                </Grid>
              ))}

              {/* EC2 Recommendation */}
              <Grid item xs={12} sm={6} md={4}>
                <Paper elevation={12} className="bar1-wrapper">
                  <Typography component="p" className="title">
                    EC2 Recommendations
                  </Typography>
                  <Typography component="p" color={"#012A4A"} className="info">
                    Forecast Possible Savings
                    <span className="saving-value">${EC2MonthlySaving}K</span>
                  </Typography>
                  <BarChart1 seriesData={EC2Barchart} />
                </Paper>
              </Grid>

              {/* EBS Recommendation */}
              <Grid item xs={12} sm={6} md={4}>
                <Paper elevation={12} className="bar1-wrapper">
                  <Typography component="p" className="title">
                    EBS Recommendations
                  </Typography>
                  <Typography component="p" color={"#012A4A"} className="info">
                    Forecast Possible Savings
                    <span className="saving-value">${EBSMonthlySaving}K</span>
                  </Typography>
                  <BarChart1 seriesData={EBSBarchart} />
                </Paper>
              </Grid>

              {/* RDS Recommendation */}
              <Grid item xs={12} sm={6} md={4}>
                <Paper elevation={12} className="bar1-wrapper">
                  <Typography component="p" className="title">
                    RDS Recommendations
                  </Typography>
                  <Typography component="p" color={"#012A4A"} className="info">
                    Forecast Possible Savings
                    <span className="saving-value">${RDSMonthlySaving}K</span>
                  </Typography>
                  <BarChart1 seriesData={RDSBarchart} />
                </Paper>
              </Grid>
            </Grid>
          </>
        )}
      </Container>
    </Box>
  );
}
